import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDesktopMediaQuery } from '@/layouts/hooks.tsx'

type LayoutContextType = {
  activeSidebarOpen: boolean
  onDesktop: boolean
  setMobileNavOpen: (open: boolean) => void
  setDesktopNavOpen: (open: boolean) => void
  mobileNavOpen: boolean
  desktopNavOpen: boolean
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined)

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const onDesktop = useDesktopMediaQuery()
  const [sidebars, setCurrentNavBarOpen] = useState({
    mobileBarIsOpen: false,
    desktopBarIsOpen: JSON.parse(
      sessionStorage.getItem('sidebarOpen') ?? 'false'
    ),
  })
  const [activeSidebarOpen, setActiveSidebarOpen] = useState(false)
  const setMobileNavOpen = (open: boolean) => {
    setCurrentNavBarOpen((prevState) => {
      return { ...prevState, mobileBarIsOpen: open }
    })
    setActiveSidebarOpen(open)
  }

  const setDesktopNavOpen = (open: boolean) => {
    setCurrentNavBarOpen((prevState) => {
      return { ...prevState, desktopBarIsOpen: open }
    })
    sessionStorage.setItem('sidebarOpen', open.toString())
    setActiveSidebarOpen(open)
  }
  useEffect(() => {
    if (onDesktop) {
      setActiveSidebarOpen(sidebars.desktopBarIsOpen)
    } else {
      setActiveSidebarOpen(sidebars.mobileBarIsOpen)
    }
  }, [onDesktop])

  return (
    <LayoutContext.Provider
      value={{
        setDesktopNavOpen,
        setMobileNavOpen,
        activeSidebarOpen,
        mobileNavOpen: sidebars.mobileBarIsOpen,
        desktopNavOpen: sidebars.desktopBarIsOpen,
        onDesktop,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

// eslint-disable-next-line
export const useLayout = () => {
  const context = useContext(LayoutContext)
  if (context === undefined) {
    throw new Error('useLayout must be used within LayoutProvider')
  }
  return context
}
